import { ChevronLeft, ChevronRight, Check } from 'lucide-react';
import { BusyDots } from '@order-up/common';

export interface StepNavigationProps {
  isFirst: boolean;
  isLast: boolean;
  canProceed: boolean;
  isSubmitting?: boolean;
  onBack: () => void;
  onNext: () => void;
}

export function StepNavigation({
  isFirst,
  isLast,
  canProceed,
  isSubmitting = false,
  onBack,
  onNext
}: StepNavigationProps) {
  return (
    <div className="flex justify-between items-center">
      <button
        type="button"
        onClick={onBack}
        disabled={isFirst || isSubmitting}
        className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all
          ${
            isFirst
              ? 'opacity-0 pointer-events-none'
              : 'bg-secondary text-zinc-300 hover:bg-zinc-700'
          }
          ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <ChevronLeft className="w-4 h-4" />
        Back
      </button>

      {!isLast ? (
        <button
          type="button"
          onClick={onNext}
          disabled={!canProceed || isSubmitting}
          className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all
            ${
              canProceed
                ? 'bg-primary-fill text-white hover:bg-primary-fill-hover'
                : 'bg-secondary text-zinc-600 cursor-not-allowed'
            }`}
        >
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      ) : (
        <button
          type="button"
          onClick={onNext}
          disabled={!canProceed || isSubmitting}
          className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all
            ${
              canProceed && !isSubmitting
                ? 'bg-primary-fill text-white hover:bg-primary-fill-hover'
                : 'bg-secondary text-zinc-600 cursor-not-allowed'
            }`}
        >
          {isSubmitting ? (
            <>
              <BusyDots className="w-4 h-4" />
              Submitting...
            </>
          ) : (
            <>
              Submit Application
              <Check className="w-4 h-4" />
            </>
          )}
        </button>
      )}
    </div>
  );
}
